<template>
<div class="w-100 h-100 p-relative">
  <nav class="library-index d-md-flex align-items-center">
    <ul v-if="libraryIndexes" class="list-unstyled">
      <li v-for="index in libraryIndexes" :key="index.id">
        <b-button variant="link" :class="selectedLibraryIndex == index.id ? 'text-dark font-weight-bold': 'text-muted'" @click="indexDidSelect(index.id)">{{ index.name }}</b-button>
      </li>
    </ul>
  </nav>
  <div class="container pt-6 pl-6 pt-md-5">
    <div class="py-md-4">
    </div>
    <h2 class="font-size-2_5rem tracking-1 text-center mb-5 d-none d-md-block">LIBRARY</h2>
    <h2 class="d-md-none mobile-section-title">LIBRARY</h2>
    <div class="libraly-container">
      <ul class="list-inline text-md-center" style="line-height: 3.3;">
        <li class="list-inline-item" v-for="library in libraries" :key="library.id">
          <b-button variant="outline-dark" @click="showDialog(library)">{{ library.title.rendered }}</b-button>
        </li>
      </ul>
    </div>

    <b-modal v-model="modalShow" :hide-footer="true">
      <template v-slot:modal-header="{ close }" class="p-0">
        <b-button size="lg" class="px-2" variant="light" @click="close()">
          <img style="width: 21px;" src="@/assets/images/cross.svg">
        </b-button>
      </template>
      <template v-if="selectedLibrary">
        <h5 class="py-2">{{ selectedLibrary.title.rendered }}</h5>
        <div v-html="selectedLibrary.content.rendered">

        </div>
      </template>

    </b-modal>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      libraries: [],
      modalShow: false,
      selectedLibrary: null
    }
  },
  mounted() {
    // TODO: このswiper-itemが表示されたら取りに行くように変更する
    this.getIndexes()
  },
  computed: {
    ...mapState({
      libraryIndexes: state => state.libraryIndexes,
      selectedLibraryIndex: state => state.selectedLibraryIndex
    }),
  },
  watch: {
    selectedLibraryIndex() {
      this.getLibraries()
    }
  },
  methods: {
    ...mapActions({
      setLibraryIndexes: 'doSetLibraryIndexes',
      setSelectedLibraryIndex: 'doSetSelectedLibraryIndex'
    }),
    indexDidSelect(indexId) {
      if(this.selectedLibraryIndex == indexId) {
        return
      } else {
        this.setSelectedLibraryIndex(indexId)
        this.getLibraries()
      }
    },
    showDialog(article) {
      console.log(article)
      this.selectedLibrary = article
      this.modalShow = true
    },
    async getIndexes() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/library_index')
          .catch((e) => {
            alert(e);
          });
      if (payload.data) {
        this.setLibraryIndexes(payload.data)
        this.setSelectedLibraryIndex(payload.data[0].id)
        this.getLibraries()
      }
    },
    async getLibraries() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/library?library_index=' + this.selectedLibraryIndex + '&per_page=100')
          .catch((e) => {
            alert(e);
          });
      console.log(payload)
      if (payload.data) {
        console.log(payload.status)
        // this.$set(this, 'news', payload.data)
        this.libraries = payload.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hover-sky {
  color: #fff;
  @media screen and (min-width: 768px){
    color: #333;
  }
}
.mobile-title {
  font-size: 1.5rem;
  @media screen and (min-width: 768px){
    font-size: 0.85rem;
  }
}
.library-index {
  position: absolute;
  left: 5px;
  bottom: 0;
  width: 50px;
  @media screen and (min-width: 768px) {
    top: 0;
    left: calc(50vw - 380px);
    height: 100%;
    bottom: inherit; 
  }
  @media screen and (min-width: 992px) {
    top: 0;
    left: calc(50% - 500px);
    height: 100%;
    bottom: inherit; 
  }
  z-index: 2;
  .btn-link {
    &:focus, &:hover {
      text-decoration: none;
      box-shadow: none;
    }
    @media screen and (max-width: 768px) {
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
  }
}
.libraly-container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  @media screen and (min-width: 768px) {
    width: 700px;
  }
  @media screen and (min-width: 992px) {
    width: 860px;
  }
}
</style>